export default '/build/0cecd391.svg'